import api from '@/utils/api'

export default {

    getStandings() {
        return api.get('standings/volley-league')
    },
    getSchedule() {
        return api.get('standings/volley-league/floisvos-schedule')
    }
}
